import React from 'react';
import fr from 'facet-rest';
import {
  ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepTemplate/Content/ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import throwInDevOutsideReact from 'Helpers/throwInDevOutsideReact';
import { RightColumnProvider } from 'Context/RightColumnContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { LottieLoadingLayout } from 'Organisms/LottieControl/LottieLoadingLayout';
import { withGuidedHouseholdReviewLayout } from 'Components/UI/guidedHouseholdReview/layoutWrapper';
import MetaControl from 'Components/UI/Meta/MetaControl';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { FDStack } from '@facet-wealth/design';
import { ImageRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/ImageRel';
import contentMetaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import {
  SecondaryActionButtonRel,
} from 'Packages/FacetCore/Experimental/RelationshipComponents/SecondaryActionButtonRel';
import { PrimaryActionButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/PrimaryActionButtonRel';
import { metaOverrideSet as metaOverrideSetForExtras } from './guidedHouseholdReviewPostSelectionNextUpActionsStepOverrides';

const Layout = withGuidedHouseholdReviewLayout(() => {
  const { resource } = useMetaLayoutContext();
  return (
    <FDStack direction="column" paddingY={2} spacing={3}>
      <FDStack direction="column" alignItems="center" paddingY={4} spacing={2}>
        <ImageRel relationship={resource.relationship(fr.relationships.image.name)} />
        <MetaControl attrName="title" resource={resource} metaOverrideSet={metaOverrideSetForExtras} />
        <FDStack justifyContent="center" spacing={3}>
          <SecondaryActionButtonRel relationship={resource.relationship(fr.relationships.learnMore.name)} />
          <PrimaryActionButtonRel relationship={resource.relationship(fr.relationships.exit.name)} />
        </FDStack>
      </FDStack>
      <ScenarioSelectionRedefinedPostSelectionNextUpActionsStepContent resource={resource} />
      <MetaControl attrName="disclaimerText" resource={resource} metaOverrideSet={metaOverrideSetForExtras} />
    </FDStack>
  );
}, {
  hideTitle: true,
  customButtons: true,
});

const GuidedHouseholdReviewPostSelectionNextUpActionsStepTemplate = ({ resource }) => {
  return (
    <SelectScenarioContextProvider onSelectSuccess={() => throwInDevOutsideReact('onSelectSuccess should not have been called')}>
      <RightColumnProvider>
        <LottieLoadingLayout>
          <MetaResourceRenderer resource={resource} layout={Layout} metaOverrideSet={contentMetaOverrideSet} />
        </LottieLoadingLayout>
      </RightColumnProvider>
    </SelectScenarioContextProvider>
  );
};

export { GuidedHouseholdReviewPostSelectionNextUpActionsStepTemplate };
